// src/views/customer/component/CreditOverviewComponent.jsx
import React from 'react';
import PropTypes from 'prop-types';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';

/**
 * Displays Total, Used, and Remaining credit.
 *
 * Props:
 *  - creditData: object with numeric fields { totalCredit, usedCredit, remainingCredit }
 *  - isLoading: optional boolean; if true, shows a loading placeholder.
 */
const CreditOverviewComponent = ({ creditData = {}, isLoading = false }) => {
    if (isLoading) {
        // You can replace these with skeleton/UI placeholders as desired
        return (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                {[0, 1, 2].map((i) => (
                    <div key={i} className="p-4 rounded-lg bg-gray-200 animate-pulse">
                        <h4 className="text-lg font-semibold mb-2 bg-gray-300 h-6 w-1/3" />
                        <p className="text-xl font-bold bg-gray-300 h-8 w-2/3" />
                    </div>
                ))}
            </div>
        );
    }

    // Safely convert to numbers; if missing or not a number, default to 0
    const total = Number(creditData.totalCredit) || 0;
    const used = Number(creditData.usedCredit) || 0;
    const remaining = Number(creditData.remainingCredit) || 0;

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="p-4 rounded-lg bg-[#FF4F99] text-white">
                <h4 className="text-lg font-semibold mb-2">Total Credit</h4>
                <p className="text-xl font-bold">
                    <CurrencyCodeAdd price={total} />
                </p>
            </div>
            <div className="p-4 rounded-lg bg-[#8262FE] text-white">
                <h4 className="text-lg font-semibold mb-2">Used Credit</h4>
                <p className="text-xl font-bold">
                    <CurrencyCodeAdd price={used} />
                </p>
            </div>
            <div className="p-4 rounded-lg bg-[#567DFF] text-white">
                <h4 className="text-lg font-semibold mb-2">Remaining Credit</h4>
                <p className="text-xl font-bold">
                    <CurrencyCodeAdd price={remaining} />
                </p>
            </div>
        </div>
    );
};

CreditOverviewComponent.propTypes = {
    creditData: PropTypes.shape({
        totalCredit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        usedCredit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        remainingCredit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    isLoading: PropTypes.bool,
};

export default CreditOverviewComponent;
